export const JIRA_COMPLETION_COLUMN_COPY = {
  section: "When the SuperPlane task completes",
  move: "Move Jira ticket to",
  column: "Jira column",
  loading: "Loading columns...",
  empty: "This project has no columns SuperPlane can move the issue to.",
} as const;
